import { render, staticRenderFns } from "./ProdesMataAtlantica.vue?vue&type=template&id=2127968f&lang=pug"
import script from "./ProdesMataAtlantica.vue?vue&type=script&lang=js"
export * from "./ProdesMataAtlantica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports